import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {ERouterPages} from '@entities/router/router.enums';
import {ESnackbarType} from '@entities/ui/snackbar';
import {AuthenticationFacade} from '@shared/facades/authentication.facade';
import {RouterFacade} from '@shared/facades/router.facade';
import {SnackbarHelper} from '@shared/helper';
import {TranslateHelper} from '@binotel-frontend/bnt-common-components';

export const isAuthenticatedGuard: CanActivateFn = () => {
  const authFacade = inject(AuthenticationFacade);
  const routerFacade = inject(RouterFacade);

  if (authFacade.$isAuthenticated()) {
    return true;
  }

  SnackbarHelper.open(
    TranslateHelper.translate('authentication.sign-in-first'),
    ESnackbarType.Error
  );

  routerFacade.go([ERouterPages.Root]);
  return false;
};
